import styles from './BimCadaplusLogo.module.scss'

/**
 * BimCadaplusLogo — inlined CADAPLUS SVG mark + wordmark as a link.
 *
 * Always links to https://bim.cadaplus.com/ (opens in new tab).
 *
 * The SVG is inlined (not loaded as an asset) so it is always bundled
 * and works regardless of asset CDN paths.
 *
 * @param {object}  props
 * @param {string}  [props.className]  - Extra class on the root <a>
 */
export function BimCadaplusLogo({ className }) {
  return (
    <a
      href="https://bim.cadaplus.com/"
      target="_blank"
      rel="noopener noreferrer"
      className={[styles.bimLogo, className].filter(Boolean).join(' ')}
      aria-label="BIM CADAPLUS"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 1000 207"
        aria-hidden="true"
        focusable="false"
      >
        {/* Wordmark – dark */}
        <path
          fill="currentColor"
          d="M510 24A91 91 0 0 1 529 26A50 50 0 0 1 565 63A73 73 0 0 1 565 92A51 51 0 0 1 528 127A69 69 0 0 1 510 129 L486 129 486 180 447 180 447 24 486 24 486 24 510 24zM501 97A38 38 0 0 0 511 96A20 20 0 0 0 525 84A42 42 0 0 0 525 70A19 19 0 0 0 512 56A59 59 0 0 0 501 55 L486 55 486 97 501 97zM425 180 L361 24 323 24 261 180 289 180 A20 20 0 0 0 308 166 L315 147 370 147 378 167 A20 20 0 0 0 397 180 L425 180zM342 63 L361 116 324 116 342 63zM886 144 L877 159 A98 98 0 0 0 912 179A74 74 0 0 0 958 176A47 47 0 0 0 984 152A58 58 0 0 0 987 115A46 46 0 0 0 960 89A228 228 0 0 1 928 77A12 12 0 0 1 920 67A13 13 0 0 1 928 56A25 25 0 0 1 945 54A59 59 0 0 1 960 62A13 13 0 0 0 976 58 L987 40 A86 86 0 0 0 950 23A68 68 0 0 0 902 32A47 47 0 0 0 883 65A48 48 0 0 0 895 101A69 69 0 0 0 927 116A43 43 0 0 1 947 125A14 14 0 0 1 948 143A21 21 0 0 1 931 149A50 50 0 0 1 912 143 L906 139 A15 15 0 0 0 886 144zM758 121A29 29 0 0 0 815 121 L815 24 855 24 855 121 A66 66 0 0 1 827 172A82 82 0 0 1 746 172A66 66 0 0 1 719 121 L719 24 758 24 758 121zM693 146 L635 146 635 24 596 24 596 180 693 180 693 146z"
        />
        {/* Mark – dark red */}
        <path
          fill="#CA5758"
          d="M108 137 L108 196 139 181 108 137zM173 166 L206 149 108 11 108 74 173 166z"
        />
        {/* Mark – light red */}
        <path
          fill="#F16664"
          d="M43 166 L11 149 108 11 108 74 43 166zM108 137 L108 196 78 181 108 137z"
        />
      </svg>
    </a>
  )
}
